import React from 'react';
import PropTypes from 'prop-types';
import { ChevronIcon } from './Icons';
import css from './SearchFiltersModalV2.module.css';

const AccordionSection = props => {
  const { label, isExpanded, onToggle, children } = props;

  return (
    <section className={css.section}>
      <button type="button" className={css.accordionToggle} onClick={onToggle}>
        <span className={css.accordionTitle}>{label}</span>
        <ChevronIcon isOpen={isExpanded} />
      </button>
      {isExpanded ? <div className={css.chipWrap}>{children}</div> : null}
    </section>
  );
};

AccordionSection.defaultProps = {
  isExpanded: false,
};

AccordionSection.propTypes = {
  label: PropTypes.node.isRequired,
  isExpanded: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default AccordionSection;
